import { useCallback, useMemo } from 'react';
import {
  useAppSelector,
  teamsState,
  useAppDispatch,
  setIsOpenJoinWorkspaceModal,
} from 'src/store';

export const useJoinWorkspaceModal = () => {
  const { isOpenJoinWorkspaceModal } = useAppSelector(teamsState);
  const dispatch = useAppDispatch();

  const onChangeIsOpenJoinWorkspaceModal = useCallback(
    (value: boolean) => {
      dispatch(setIsOpenJoinWorkspaceModal(value));
    },
    [dispatch],
  );

  return useMemo(
    () => ({
      isOpenJoinWorkspaceModal,
      onChangeIsOpenJoinWorkspaceModal,
    }),
    [isOpenJoinWorkspaceModal, onChangeIsOpenJoinWorkspaceModal],
  );
};
